import { RenderMark } from '@contentful/rich-text-react-renderer';
import { MARKS } from '@contentful/rich-text-types';

export const markRenderers: RenderMark = {
  // eslint-disable-next-line react/display-name
  [MARKS.BOLD]: text => <strong>{text}</strong>
};
